<template>
  <div
    class="viewer-element"
    ref="elementRef"
    :id="`viewer-element-${elementInfo.id}`"
    :style="{
      width: '100%', height: isSlideLayout ? '100%' : 'auto',
      zIndex: elementIndex,
      position: 'relative'
    }"
  >
    <component
        :is="currentElementComponent"
        :elementInfo="elementInfo"
        :style="{ width: '100%', height: isSlideLayout ? '100%' : 'auto' }"
    ></component>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue'
import { ElementTypes, PPTElement } from '@/types/slides'

import ImageElement from '@/views/components/element/ImageElement/index.vue'
import TextElement from '@/views/components/element/TextElement/index.vue'
import HtmlElement from '@/views/components/element/HtmlElement/index.vue'
import CalculatorViewerElement from './CalculatorViewerElement/index.vue'
import ShapeElement from '@/views/components/element/ShapeElement/index.vue'
import LineElement from '@/views/components/element/LineElement/index.vue'
import ChartElement from '@/views/components/element/ChartElement/index.vue'
import SectionElement from '@/views/components/element/SectionViewerElement/index.vue'
import TableElement from '@/views/components/element/TableElement/index.vue'
import LatexElement from '@/views/components/element/LatexElement/index.vue'
import VideoElement from '@/views/components/element/VideoElement/index.vue'
import AudioElement from '@/views/components/element/AudioElement/index.vue'
import SlideLayoutViewerElement from "@/views/components/element/SlideLayoutViewerElement/index.vue";

const props = defineProps({
  elementInfo: {
    type: Object as PropType<PPTElement>,
    required: true,
  },
  elementIndex: {
    type: Number,
    required: true,
  }
})

const isSlideLayout = computed(() => ElementTypes.SLIDE_LAYOUT === props.elementInfo.type)

const currentElementComponent = computed(() => {
  const elementTypeMap = {
    [ElementTypes.IMAGE]: ImageElement,
    [ElementTypes.TEXT]: TextElement,
    [ElementTypes.HTML]: HtmlElement,
    [ElementTypes.DRAG_DROP]: CalculatorViewerElement,
    [ElementTypes.SLIDE_LAYOUT]: SlideLayoutViewerElement,
    [ElementTypes.SHAPE]: ShapeElement,
    [ElementTypes.LINE]: LineElement,
    [ElementTypes.CHART]: ChartElement,
    [ElementTypes.SECTION]: SectionElement,
    [ElementTypes.TABLE]: TableElement,
    [ElementTypes.LATEX]: LatexElement,
    [ElementTypes.VIDEO]: VideoElement,
    [ElementTypes.AUDIO]: AudioElement,
  }
  return elementTypeMap[props.elementInfo.type] || null
})
</script>
